var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container",style:('height:'+_vm.wheight+'px')},[_c('div',{staticClass:"inner"},[_c('van-loading',{attrs:{"color":"#1989fa"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }